import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalJsonService } from '../../services/global-json/global-json.service';
import { LottosService } from '../../services/lottos/lottos.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.freeplay.html',
  styleUrls: ['./copy.component.scss']
})
export class CopyComponent implements OnInit {
  public year: any;
  public copy: any = [];
  private sys: any;
  public subs: Subscription;
  public subs2: Subscription;
  constructor(protected gcopy: GlobalJsonService, protected lotto: LottosService) {}

  ngOnInit(): void {
    this.setCopy();
  }

  setCopy(): void {
    this.setSystem();
    this.gcopy.getGlobalCopy();
  }

  setSystem(): void {
    if ( environment.lottery.lot_id !== 0 ) {
      this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
        this.sys = lottoObj['system'];
        this.showCopy(this.sys);
      });
    } else {
      this.sys = 'wt';
      this.showCopy(this.sys);
    }
  }

  showCopy(n: any): void {
    this.subs2 = this.gcopy.globalCopyObservable$.subscribe((globalObj) => {
      this.copy = globalObj[n];
    });
  }

  get currentYear() {
    let today = new Date();
    return (this.year = today.getFullYear());
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.subs2.unsubscribe();
  }
}
